/* Street Lines — 1 ks / 5 ks pack toggle.
 *
 * The two pack sizes are separate Shopify products, not variants of one, so
 * the toggle has to swap which product's variant the add-to-cart form posts.
 * Each radio carries its own variant id and formatted price.
 */
if (!customElements.get('sl-pack-toggle')) {
  customElements.define(
    'sl-pack-toggle',
    class SlPackToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-sl-variant-input]');
        this.priceEl = this.querySelector('[data-sl-price]');
        this.unitEl = this.querySelector('[data-sl-unit]');
        this.button = this.querySelector('[type="submit"]');
        this.radios = [...this.querySelectorAll('input[type="radio"][name="sl-pack"]')];
        if (!this.radios.length) return;

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.select(radio));
        });

        const checked = this.radios.find((r) => r.checked) || this.radios[0];
        if (checked) {
          checked.checked = true;
          this.select(checked);
        }
      }

      select(radio) {
        const { variantId, price, unit, available } = radio.dataset;

        if (this.input && variantId) this.input.value = variantId;
        if (this.priceEl && price) this.priceEl.textContent = price;
        if (this.unitEl && unit) this.unitEl.textContent = unit;

        // A pack can be sold out on its own; reflect that on the button.
        if (this.button) {
          const sellable = available === 'true';
          this.button.disabled = !sellable;
          const label = sellable ? this.button.dataset.labelIdle : this.button.dataset.labelOut;
          if (label) this.button.textContent = label;
        }

        this.dispatchEvent(new CustomEvent('sl:pack:change', { detail: { variantId }, bubbles: true }));
      }
    }
  );
}
